import { Tag } from '../../../../components/tags/Tag';
import { styleSheet } from './styles';
import { DefaultBulkSendExcludedTags } from '@ViewModels';
import { css } from 'aphrodite';
import * as React from 'react';

interface IProps {
	className?: string;
	maxTags?: number;
	tags: string[];
}

export class Tags extends React.PureComponent<IProps> {
	public render() {
		const { tags, maxTags, className } = this.props;

		const filteredTags = tags?.filter(x => !DefaultBulkSendExcludedTags.has(x));
		const overflowTagsCount = maxTags ? filteredTags.length - maxTags : 0;
		const visibleTags = !maxTags || filteredTags.length <= maxTags ? filteredTags : filteredTags.slice(0, maxTags);

		return (
			<div className={`${css(styleSheet.container)} tags ${className || ''}`}>
				<div className={css(styleSheet.content)}>
					{visibleTags.map(x => {
						return <Tag className={css(styleSheet.tag)} key={x} tagValue={x} />;
					})}
					{overflowTagsCount > 0 && (
						<span className={css(styleSheet.tag, styleSheet.overflow)}>&nbsp;{`+${overflowTagsCount} more`}</span>
					)}
				</div>
			</div>
		);
	}
}
